import React from 'react';
import './styles.scss';

const Error = ({ message }) => <div className="Error">{message}</div>;

export default Error;
